/**
 * Key is a string we get for selected Question Type
 */
const TemplateQuestionLabelOptions: { [key: string]: string } = {
    'Freeform Question': 'performance.templates.freeFormLabel',
    'Rating Question': 'performance.templates.ratingLabel',
    'Agree / Disagree Question': 'performance.templates.agreeDisagreeLabel',
    'True / False Question': 'performance.templates.trueFalseLabel',
    'Multiple Choice Question': 'performance.templates.multipleChoiceLabel',
};

export { TemplateQuestionLabelOptions };
